import { cubicOut } from 'svelte/easing';
import { blur, fade, fly, scale } from 'svelte/transition';

import {
    TRANSITION_BLUR_AMOUNT,
    TRANSITION_DEFAULT_Y_OFFSET,
    TRANSITION_DURATION,
    TRANSITION_DURATION_SLOW,
    TRANSITION_SCALE_START,
    TRANSITION_SLIDE_Y_OFFSET,
} from './constants';

import type { TransitionEffect } from '$lib/types/Theme';

const getTransitionFunction = (effect: TransitionEffect) =>
    ({
        default: fly,
        slide: fly,
        scale: scale,
        fade: fade,
        blur: blur,
        none: fly,
    })[effect] || fly;

const getTransitionDuration = (effect: TransitionEffect) => {
    if (effect === 'none') {
        return 0;
    } else if (effect === 'blur' || effect === 'fade') {
        return TRANSITION_DURATION_SLOW;
    } else {
        return TRANSITION_DURATION;
    }
};

const getTransitionProps = (effect: TransitionEffect) => ({
    easing: cubicOut,
    duration: getTransitionDuration(effect),
    ...(effect === 'default' || !effect
        ? {
              y: TRANSITION_DEFAULT_Y_OFFSET,
          }
        : {}),
    ...(effect === 'slide'
        ? {
              y: TRANSITION_SLIDE_Y_OFFSET,
          }
        : {}),
    ...(effect === 'blur'
        ? {
              amount: TRANSITION_BLUR_AMOUNT,
          }
        : {}),
    ...(effect === 'scale'
        ? {
              start: TRANSITION_SCALE_START,
          }
        : {}),
});

export const getTransitionData = (effect: TransitionEffect) => {
    const transitionFunction = getTransitionFunction(effect);
    const transitionProps = getTransitionProps(effect);

    return {
        transitionFunction: transitionFunction,
        transitionProps: transitionProps,
    };
};
